import axios from "axios";
import { CorporateExperimentByBusiness } from "../../types";
import { config } from "../config";

const END_POINT = "/api/v0/experiments/business";

export const fetchCorporateExperimentsByBusiness = async (): Promise<
  CorporateExperimentByBusiness[]
> => {
  const { data } = await axios.put(END_POINT, {}, { baseURL: config.baseURL });
  return data.experiments;
};
